<div class="tw:container tw:mx-auto tw:p-4">
  <h2 class="admin-h2">Client report</h2>
  @switch (state) {
    @case ('loading') {
      <p id="clientReportLoading">Opening the report…</p>
    }
    @case ('shown') {
      <iframe [src]="reportFrameUrl" frameborder="0" class="responsive-iframe" title="Client report"></iframe>
    }
    @case ('saved') {
      <p id="clientReportSaved">The report has been downloaded.</p>
    }
    @case ('missing') {
      <p id="clientReportMissing">This report could not be found, or it is not available to your account.</p>
    }
  }
</div>